import { useMutation, useQuery } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";
import qs from "qs";

export function useSheduleTradicionalList(filters: any, option: boolean = false) {
  return useQuery(
    [URL.AGENDA.TRADICIONAL, filters],
    async () => {
      const { data } = await http.get(URL.AGENDA.TRADICIONAL, {
        params: filters,
        paramsSerializer: (params) =>
          qs.stringify(params, { indices: false }),
      });

      return data;
    },
    {
      keepPreviousData: true,
      enabled: !!filters?.SafraPeriodoIds?.length && !!filters?.DataPeriodoInicial && !!filters?.DataPeriodoFim && option,
    }
  );
}

export type SheduleTalhao = {
  talhaoId: string;
  talhao: string;
  dataProgramada: string;
  totalAreaPlanejada: number;
  totalAreaExecutadaParcial: number;
  totalAreaAtrasada: number;
  totalAreaExecutada: number;
};

export type SheduleWindowExecution = {
  talhaoId: string;
  periodoDataInicio: string;
  periodoDataFim: string;
  totalAreaPlanejada: number;
  totalAreaExecutadaParcial: number;
  totalAreaAtrasada: number;
  totalAreaExecutada: number;
};


export function useSheduleTalhaoList(filters: any, option: boolean = false) {
  return useQuery(
    [URL.AGENDA.TALHAO, filters],
    async () => {
      try {
        if (filters?.DataPeriodoFim) {
          delete filters.DataPeriodoFim;
        }

        const { data } = await http.get<SheduleTalhao[]>(URL.AGENDA.TALHAO, {
          params: filters,
          paramsSerializer: (params) =>
            qs.stringify(params, { indices: false }),
        });

        return data.sort((a, b) => {
          const dateCompare = a.dataProgramada.localeCompare(b.dataProgramada);
          if (dateCompare !== 0) {
            return dateCompare;
          }
          return a.talhao.localeCompare(b.talhao, undefined, { numeric: true });
        });
      } catch (error) {
        console.log(error);
        return [];
      }

    },
    {
      keepPreviousData: true,
      enabled: !!filters?.SafraPeriodoIds?.length && !!filters?.DataPeriodoInicial && option,
    }
  );
}
export function useSheduleDetailList(filters: any, option: boolean = false) {
  return useQuery(
    [URL.AGENDA.DETALHE, filters],
    async () => {
      if (filters?.DataPeriodoInicial) {
        delete filters.DataPeriodoInicial;
      }
      if (filters?.DataPeriodoFim) {
        delete filters.DataPeriodoFim;
      }
      const { data } = await http.get(URL.AGENDA.DETALHE, {
        params: filters,
        paramsSerializer: (params) =>
          qs.stringify(params, { indices: false }),
      });

      return data.sort((a: any, b: any) =>
        a?.talhao.localeCompare(b?.talhao, undefined, {
          numeric: true,
          sensitivity: "base",
        })
      );
    },
    {
      keepPreviousData: true,
      enabled: !!filters?.SafraPeriodoIds?.length && !!filters?.Data && option,
    }
  );
}

export function useSheduleDetailExport() {
  return useMutation({
    mutationKey: [URL.AGENDA.EXPORTAR_PDF],
    mutationFn: async (filters: any) => {
      const { data } = await http.get(URL.AGENDA.EXPORTAR_PDF, {
        params: filters,
        paramsSerializer: (params) =>
          qs.stringify(params, { indices: false }),
        responseType: "blob",
      });
      return data;
    },
  });
}

export function useSheduleJanelaExecucaoList(filters: any, option: boolean = false) {
  return useQuery(
    [URL.AGENDA.JANELA_EXECUCAO, filters],
    async () => {
      try {
        const { data } = await http.get<SheduleWindowExecution[]>(URL.AGENDA.JANELA_EXECUCAO, {
          params: filters,
          paramsSerializer: (params) =>
            qs.stringify(params, { indices: false }),
        });

        return data.sort((a: any, b: any) => {
          const getDataOrdenacao = (item: any) => {
            const dataRef = item.periodoDataInicio;

            return dataRef ? new Date(dataRef).getTime() : Infinity;
          };

          return getDataOrdenacao(a) - getDataOrdenacao(b);
        });
      } catch (error) {
        console.log(error);
        return [];
      }
    },
    {
      keepPreviousData: true,
      enabled: !!filters?.SafraPeriodoIds?.length && !!filters?.DataPeriodoInicial && option,
    }
  );
}

export function useSheduleJanelaExecucaoDetalhe(
  filters: any,
  datas: { PeriodoDataInicio: string; PeriodoDataFim: string }[],
  option: boolean = false
) {

  return useQuery(
    [URL.AGENDA.JANELA_EXECUCAO_DETALHE, filters, datas],
    async () => {
      const responses = await Promise.all(
        datas.map(async ({ PeriodoDataInicio, PeriodoDataFim }) => {
          const { data } = await http.get(URL.AGENDA.JANELA_EXECUCAO_DETALHE, {
            params: {
              ...filters,
              PeriodoDataInicio,
              PeriodoDataFim,
            },
            paramsSerializer: (params) =>
              qs.stringify(params, { indices: false }),
          });
          return data.sort((a: any, b: any) =>
            a?.talhao.localeCompare(b?.talhao, undefined, {
              numeric: true,
              sensitivity: "base",
            })
          );
        })
      );

      return responses.flat();
    },
    {
      keepPreviousData: true,
      enabled:
        !!filters?.SafraPeriodoIds?.length &&
        !!datas?.length &&
        option,
    }
  );
}